import React from 'react';
import { compose } from 'ramda';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from '../style';
import Modal from '@synergycms_core/components/generic/Modal';
import Image from '@synergycms_core/components/generic/Image';
import RichText from '@synergycms_core/components/generic/RichText';
import Button from '@synergycms_core/components/generic/Button';

import LoyaltyAccount from '../Account/index';


const FidelTourModal = ({ content, currentStep, children, view, closeCallback, theme, theme: { styles: { classes }}}) => {
  const isMobile = theme && theme.width < 901;

  const getLoyaltyLogoText = (key) => {
    const translated = content ? content.t(`_%${key}%_`) : '';
    return translated.trim() !== '' && translated !== key ? translated : null;
  };

  const loyaltyLogoText = getLoyaltyLogoText(isMobile ? 'loyalty_logo_text_mobile' : 'loyalty_logo_text');
  const loyaltyLogoTextModal = getLoyaltyLogoText(isMobile ? 'loyalty_logo_text_modal_mobile' : 'loyalty_logo_text_modal');
  const logoText = loyaltyLogoTextModal || loyaltyLogoText || '';

  return (
    <Modal
      modalStyle={[classes.modal,classes.modalContainer, view].join(' ')}
      typeModal={ "LoyaltyModal" }
      popover = { (closeModal) =>
        <>
          <div className={[classes.ftLogoModal, loyaltyLogoText ? classes.ftLogoModalModified : ''].join(' ')}>
            { !!logoText ? (
                <div className={classes.logoTextBox}>
                  <RichText
                    text={logoText}
                    translate={true}
                    dangerouslySetInnerHTML={true}
                    innerStyle={classes.loyaltyTabLogo}
                  />
                </div>
              ) : (
                <Image svg={'memberOnlyBlue'} innerStyle={classes.loyaltyLogo}/>
              )}
          </div>
          <div className={[classes.textUnderLogo].join(' ')}>
            <RichText  text={'_%esta oferta es exclusiva para clientes registrados. Introduce tus datos de acceso o regístrate para acceder a ventajas exclusivas.%_'} translate={true} ucFirst={true} />
            {' '}
            <RichText innerStyle={['uppercase', classes.boldText]} text={'_%¡es gratis!%_'} translate={true} />
          </div>
          <div className={classes.content}>
            <LoyaltyAccount initView={view}/>
          </div>
          {currentStep === 'monoHotelAvail' && (
            <div className={[classes.textUnderLogo, classes.clickGeneralFees].join(" ")}>
              <RichText text={"_%o haz click%_"} translate={true} ucFirst={true} />{" "}
              <Button 
                onClick={() => {closeCallback(); closeModal()}}
                richText={{
                  text: '_%aqui%_',
                  innerStyle: ["uppercase", classes.boldText, classes.loyaltyTextColor],
                  translate: true
                }}/>{" "}
              <RichText
                text={"_%para acceder a nuestras tarifas generales.%_"}
                translate={true}
                ucFirst={false}
              />
            </div>
          )}
        </>
      }>
      {children}
    </Modal>
  );
};

export default compose(
  withThemeJSS({ styleFile, displayName:'style', link: true }),
  withContent('i18n')
)(FidelTourModal);

